import { useState } from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import RequestPageOutlined from "@mui/icons-material/RequestPageOutlined";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import downloadBoleto from "lib/api/download-boleto";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { downloadNotaDocumento } from "./utils";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: "0.75rem",
    cursor: "pointer",
    borderRadius: 4,
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: themeColorsDesingSystem.stone.light,
    },
  },
  wrapperDisabled: {
    cursor: "not-allowed",
    opacity: 0.45,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  iconBox: {
    width: 56,
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: themeColorsDesingSystem.gray.main,
  },
  label: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: themeColorsDesingSystem.gray.dark,
    textAlign: "center",
    lineHeight: 1.3,
  },
});

export default function DocumentDownloadItem({
  label,
  disponivel,
  tipo,
  chaveNf,
  numeroTitulo,
  formatoArquivo,
  pdfNoS3,
  xmlNoS3,
  preferXml,
}) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!disponivel || isDownloading) {
      if (!disponivel) {
        snackbar.showMessage("Documento não disponível para download.", {
          severity: "info",
        });
      }
      return;
    }

    setIsDownloading(true);

    try {
      if (tipo === "boleto") {
        await downloadBoleto("encontro-contas", numeroTitulo);
        return;
      }

      if (tipo === "nota") {
        await downloadNotaDocumento({
          chaveNf,
          formatoArquivo,
          pdfNoS3,
          xmlNoS3,
          preferXml,
        });
        return;
      }

      snackbar.showMessage("Documento não disponível para download.", {
        severity: "info",
      });
    } catch (error) {
      snackbar.showMessage(
        error || "Erro ao baixar o documento. Tente novamente.",
        { severity: "error" },
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Box
      className={`${classes.wrapper} ${!disponivel ? classes.wrapperDisabled : ""}`}
      onClick={handleDownload}
      role="button"
      tabIndex={disponivel ? 0 : -1}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleDownload();
        }
      }}
      aria-label={label}
      aria-disabled={!disponivel}
    >
      <Box className={classes.iconBox}>
        <RequestPageOutlined
          style={{ fontSize: 40 }}
          color={disponivel ? "action" : "disabled"}
        />
      </Box>
      <Typography className={classes.label}>
        {isDownloading ? "Baixando..." : label}
      </Typography>
    </Box>
  );
}
